import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Textarea } from "rbx";
import { SystemCodeSelect } from "../inputs";

const CustomerNoteForm = ({ inputs, onChange }) => (
  <div style={{ minWidth: "40vw" }}>
    <Field>
      <Control>
        <SystemCodeSelect
          icon="sticky-note"
          label="Note Type"
          lookup={{ Code: "CustNoteType" }}
          name="NoteTypeRecIdRef"
          value={inputs.NoteTypeRecIdRef}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field>
      <Label>Note</Label>
      <Control>
        <Textarea
          name="Note"
          rows="10"
          value={inputs.Note}
          onChange={onChange}
        />
      </Control>
    </Field>
  </div>
);

CustomerNoteForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

export default CustomerNoteForm;
